/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './pagination';
import '../model/shared/device_profile_type';
import '../model/shared/device_profile';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "SearchDeviceProfilesV2Request": {
                        "fields": {
                          "query": {
                            "type": ".squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Query",
                            "id": 1,
                            "rule": "optional"
                          },
                          "pagination": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Pagination",
                            "id": 2,
                            "rule": "optional"
                          },
                          "includeLinkedDevicesCount": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeTotalProfileCount": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "SearchDeviceProfilesV2Query": {
                        "fields": {
                          "filter": {
                            "type": ".squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Filter",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "SearchDeviceProfilesV2Filter": {
                        "fields": {
                          "idFilter": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "typeFilter": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "scopeFilter": {
                            "type": ".squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Filter.ProfileScope",
                            "id": 3,
                            "rule": "optional"
                          },
                          "nameFilter": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "sortField": {
                            "type": ".squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Filter.SortField",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": "CREATED_AT"
                            }
                          },
                          "sortDirection": {
                            "type": ".squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Filter.SortDirection",
                            "id": 6,
                            "rule": "optional",
                            "options": {
                              "default": "DESC"
                            }
                          }
                        },
                        "nested": {
                          "ProfileScope": {
                            "values": {
                              "PRIVATE_AND_SHARED": 0,
                              "SHARED": 1,
                              "PRIVATE": 2
                            }
                          },
                          "SortField": {
                            "values": {
                              "CREATED_AT": 1,
                              "DEVICE_PROFILE_NAME": 2
                            }
                          },
                          "SortDirection": {
                            "values": {
                              "DESC": 1,
                              "ASC": 2
                            }
                          }
                        }
                      },
                      "SearchDeviceProfilesV2Response": {
                        "fields": {
                          "profileResults": {
                            "type": ".squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesResult",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "cursor": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "totalProfileCount": {
                            "type": "uint32",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "SearchDeviceProfilesResult": {
                        "fields": {
                          "deviceProfile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                            "id": 1,
                            "rule": "optional"
                          },
                          "linkedDeviceCount": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SearchDeviceProfilesV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SearchDeviceProfilesV2Query && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SearchDeviceProfilesV2Filter && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SearchDeviceProfilesV2Filter?.nested?.ProfileScope && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SearchDeviceProfilesV2Filter?.nested?.SortField && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SearchDeviceProfilesV2Filter?.nested?.SortDirection && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SearchDeviceProfilesV2Response && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SearchDeviceProfilesResult) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchDeviceProfilesV2Request @ squareup/devicesettings/profiles/v2/message/search_device_profiles.proto at 13:1
 */
export const SearchDeviceProfilesV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Request');
fixType(SearchDeviceProfilesV2Request, {
  query: {
    required: true
  }
});
Builder.createAndAttachToType(SearchDeviceProfilesV2Request);
/**
 * SOURCE SearchDeviceProfilesV2Query @ squareup/devicesettings/profiles/v2/message/search_device_profiles.proto at 20:1
 */
export const SearchDeviceProfilesV2Query = $root.lookupType('squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Query');
fixType(SearchDeviceProfilesV2Query, {
  filter: {
    required: true
  }
});
Builder.createAndAttachToType(SearchDeviceProfilesV2Query);
/**
 * SOURCE SearchDeviceProfilesV2Filter @ squareup/devicesettings/profiles/v2/message/search_device_profiles.proto at 24:1
 */
export const SearchDeviceProfilesV2Filter = $root.lookupType('squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Filter');
fixType(SearchDeviceProfilesV2Filter);
Builder.createAndAttachToType(SearchDeviceProfilesV2Filter);
/**
 * SOURCE ProfileScope @ squareup/devicesettings/profiles/v2/message/search_device_profiles.proto at 43:3
 */
SearchDeviceProfilesV2Filter.ProfileScope = $root.lookupEnum('squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Filter.ProfileScope').values;
/**
 * SOURCE SortField @ squareup/devicesettings/profiles/v2/message/search_device_profiles.proto at 60:3
 */
SearchDeviceProfilesV2Filter.SortField = $root.lookupEnum('squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Filter.SortField').values;
/**
 * SOURCE SortDirection @ squareup/devicesettings/profiles/v2/message/search_device_profiles.proto at 69:3
 */
SearchDeviceProfilesV2Filter.SortDirection = $root.lookupEnum('squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Filter.SortDirection').values;
/**
 * SOURCE SearchDeviceProfilesV2Response @ squareup/devicesettings/profiles/v2/message/search_device_profiles.proto at 75:1
 */
export const SearchDeviceProfilesV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesV2Response');
fixType(SearchDeviceProfilesV2Response);
Builder.createAndAttachToType(SearchDeviceProfilesV2Response);
/**
 * SOURCE SearchDeviceProfilesResult @ squareup/devicesettings/profiles/v2/message/search_device_profiles.proto at 81:1
 */
export const SearchDeviceProfilesResult = $root.lookupType('squareup.devicesettings.profiles.v2.message.SearchDeviceProfilesResult');
fixType(SearchDeviceProfilesResult);
Builder.createAndAttachToType(SearchDeviceProfilesResult);